export default "__VITE_ASSET__V59SRoAL__"